<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'huandeng',
})
</script>
<template>

    <a-carousel v-if="data"  :autoplay="true" :style="{color:data.color}">
      <template #prevArrow>
        <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
          <left-circle-outlined />
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow" style="right: 10px">
          <right-circle-outlined />
        </div>
      </template>
      <div v-for="(item,i) in data.child" :key="i" >
        <div class="bg-img content-box-huandeng" :style="{background:('url('+addip(item.pic)+')')}">
          <div class="auto-container" style="height: 100%;">
          <div v-if="data.showtitle>0" class="content-title  flex-column justify-end">
            <h1>{{ item.name }}</h1>
            <h3 v-if="item.sub">{{ item.sub }}</h3>
            <h3 v-if="item.url"><a :href="item.url" class="btn-primary"   size="large" >
              详情 <ArrowRightOutlined />
            </a></h3>
          </div>
          </div>
        </div>
      </div>
    </a-carousel>
</template>
<script  lang="ts" setup name="huandeng">
import {defineComponent,defineProps  } from 'vue';
import {addip} from '@/utils/util'
import { LeftCircleOutlined, RightCircleOutlined,ArrowRightOutlined } from '@ant-design/icons-vue';
defineProps({
  data:Object
})
</script>

<style lang="less">
  @menu-height:80px;
  @import '@/style/main.less';
  .huandeng{

    .content-box-huandeng{
      height: 100vh;background-repeat: no-repeat !important;;background-size: cover !important;;background-position: center !important;position: relative;color:white;
      .content-title{height: 100%;}
    }

  }
  .huandeng > .auto-container{padding:0;}
</style>
